.overlay-wrapper {
  position: absolute;
}

.container {
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
  height: 100%;
}

.content {
  flex: 1;
  max-width: 100%;
  overflow-y: auto;
}
